export const DONGTAN_CENTER = { lat: 37.2006, lng: 127.0976 } as const;
export const HWASEONG_LAWD_CD = '41590';

export const DONGTAN_DISTRICTS = {
  DONGTAN_1DONG: {
    name: '동탄1동',
    dongs: ['반송동', '석우동'],
    center: { lat: 37.205, lng: 127.072 },
  },
  DONGTAN_2DONG: {
    name: '동탄2동',
    dongs: ['반송동'],
    center: { lat: 37.2065, lng: 127.0635 },
  },
  DONGTAN_3DONG: {
    name: '동탄3동',
    dongs: ['능동'],
    center: { lat: 37.2001, lng: 127.0955 },
  },
  DONGTAN_4DONG: {
    name: '동탄4동',
    dongs: ['청계동'],
    center: { lat: 37.1964, lng: 127.1018 },
  },
  DONGTAN_5DONG: {
    name: '동탄5동',
    dongs: ['영천동', '중동'],
    center: { lat: 37.1915, lng: 127.095 },
  },
  DONGTAN_6DONG: {
    name: '동탄6동',
    dongs: ['금곡동', '방교동', '오산동'],
    center: { lat: 37.1782, lng: 127.0876 },
  },
  DONGTAN_7DONG: {
    name: '동탄7동',
    dongs: ['산척동', '송동'],
    center: { lat: 37.181, lng: 127.105 },
  },
  DONGTAN_8DONG: {
    name: '동탄8동',
    dongs: ['장지동'],
    center: { lat: 37.188, lng: 127.112 },
  },
  DONGTAN_9DONG: {
    name: '동탄9동',
    dongs: ['목동', '신동'],
    center: { lat: 37.1755, lng: 127.098 },
  },
} as const;

/** 기존 enum 값 → 새 동탄X동 매핑 (DB 마이그레이션용) */
export const LEGACY_AREA_MAP: Record<string, string> = {
  DONGTAN_1: 'DONGTAN_1DONG',
  DONGTAN_2: 'DONGTAN_7DONG',
  DONGTAN_STATION: 'DONGTAN_3DONG',
  BANSEONG: 'DONGTAN_2DONG',
  SEOKWU: 'DONGTAN_1DONG',
  NEUNGDONG: 'DONGTAN_3DONG',
  CHEONGYE: 'DONGTAN_4DONG',
  YEONGCHEON: 'DONGTAN_5DONG',
  BANGYO: 'DONGTAN_6DONG',
  GEUMGOK: 'DONGTAN_6DONG',
  MOKDONG_HW: 'DONGTAN_9DONG',
  SANCHEOK: 'DONGTAN_7DONG',
  JANGJI: 'DONGTAN_8DONG',
  SONGDONG: 'DONGTAN_7DONG',
  OSAN_AREA: 'DONGTAN_6DONG',
};

export type DongtanDistrictKey = keyof typeof DONGTAN_DISTRICTS;

/** 동탄1신도시 지역 코드 (1~3동) */
export const DONGTAN1_AREAS = [
  'DONGTAN_1DONG',
  'DONGTAN_2DONG',
  'DONGTAN_3DONG',
] as const;

/** 동탄2신도시 지역 코드 (4~9동) */
export const DONGTAN2_AREAS = [
  'DONGTAN_4DONG',
  'DONGTAN_5DONG',
  'DONGTAN_6DONG',
  'DONGTAN_7DONG',
  'DONGTAN_8DONG',
  'DONGTAN_9DONG',
] as const;

/** 동탄 전체 지역 코드 (1~9동) */
export const DONGTAN_ALL_AREAS = [
  ...DONGTAN1_AREAS,
  ...DONGTAN2_AREAS,
] as const;

/** 행정동 → 소속 신도시 */
export const AREA_TO_CITY: Record<string, '동탄1신도시' | '동탄2신도시'> = {
  DONGTAN_1DONG: '동탄1신도시',
  DONGTAN_2DONG: '동탄1신도시',
  DONGTAN_3DONG: '동탄1신도시',
  DONGTAN_4DONG: '동탄2신도시',
  DONGTAN_5DONG: '동탄2신도시',
  DONGTAN_6DONG: '동탄2신도시',
  DONGTAN_7DONG: '동탄2신도시',
  DONGTAN_8DONG: '동탄2신도시',
  DONGTAN_9DONG: '동탄2신도시',
};

/** 법정동 → 행정동 매핑 */
export const LAWDDONG_TO_AREA: Record<string, string> = {
  // 동탄1신도시
  '반송동': 'DONGTAN_2DONG',
  '석우동': 'DONGTAN_1DONG',
  '동탄동': 'DONGTAN_2DONG',
  '능동': 'DONGTAN_3DONG',
  // 동탄2신도시
  '청계동': 'DONGTAN_4DONG',
  '영천동': 'DONGTAN_5DONG',
  '중동': 'DONGTAN_5DONG',
  '오산동': 'DONGTAN_6DONG',
  '금곡동': 'DONGTAN_6DONG',
  '기산동': 'DONGTAN_6DONG',
  '방교동': 'DONGTAN_6DONG',
  '산척동': 'DONGTAN_7DONG',
  '송동': 'DONGTAN_7DONG',
  '장지동': 'DONGTAN_8DONG',
  '목동': 'DONGTAN_9DONG',
  '신동': 'DONGTAN_9DONG',
};

/** 동탄1신도시 법정동 */
export const DONGTAN1_LAWDDONGS = ['석우동', '반송동', '동탄동', '능동'] as const;

/** 동탄2신도시 법정동 */
export const DONGTAN2_LAWDDONGS = [
  '영천동', '오산동', '청계동', '신동', '중동',
  '목동', '산척동', '방교동', '장지동', '금곡동', '기산동', '송동',
] as const;

export const DONGTAN_DONGS = [
  ...DONGTAN1_LAWDDONGS,
  ...DONGTAN2_LAWDDONGS,
  '배양동',
  '기산동',
] as const;

/** 지역코드 → 한글 라벨 (법정동 기준) */
export const AREA_LABEL: Record<string, string> = {
  DONGTAN_1DONG: '석우동',
  DONGTAN_2DONG: '반송동',
  DONGTAN_3DONG: '능동',
  DONGTAN_4DONG: '청계동',
  DONGTAN_5DONG: '영천동·중동',
  DONGTAN_6DONG: '금곡동·방교동·오산동',
  DONGTAN_7DONG: '산척동·송동',
  DONGTAN_8DONG: '장지동',
  DONGTAN_9DONG: '목동·신동',
  DONGTAN1: '동탄1신도시',
  DONGTAN2: '동탄2신도시',
};

export const MAP_ZOOM = {
  DONGTAN_OVERVIEW: 12,
  DISTRICT_VIEW: 14,
  PROPERTY_VIEW: 16,
} as const;
